const CACHE_VERSION = 'v1';
const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 h

// Prefix every key with the cache version so a schema change auto-invalidates
// all stale entries on the next deployment.
const vk = (key) => `${CACHE_VERSION}:${key}`;

export const saveCache = (key, data) => {
  try {
    localStorage.setItem(vk(key), JSON.stringify({ data, ts: Date.now() }));
  } catch { /* quota exceeded — silently skip */ }
};

export const loadCache = (key, ttlMs = CACHE_TTL_MS) => {
  try {
    const raw = localStorage.getItem(vk(key));
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    if (Date.now() - ts > ttlMs) return null;
    return data;
  } catch { return null; }
};

export const clearCache = (key) => {
  try { localStorage.removeItem(vk(key)); } catch { /* noop */ }
};

// Remove all versioned entries that have exceeded their TTL.
export const clearStaleCache = () => {
  try {
    const now = Date.now();
    const prefix = `${CACHE_VERSION}:`;
    Object.keys(localStorage)
      .filter(k => k.startsWith(prefix))
      .forEach(k => {
        try {
          const { ts } = JSON.parse(localStorage.getItem(k));
          if (now - ts > CACHE_TTL_MS) localStorage.removeItem(k);
        } catch { localStorage.removeItem(k); }
      });
  } catch { /* noop */ }
};

export const CACHE_KEYS = {
  products: 'kiosk:products',
  artists: 'kiosk:artists',
  artist: (id) => `kiosk:artist:${id}`,
  loopVideos: 'kiosk:loop-videos',
};
